module.exports = __webpack_public_path__ + "media/smw_princess_help.6db08fe8.ogg";